// Helper utilities for adding/removing small diagnostic overlay layers (fills/lines/points)
// Keep types broad to be compatible with the MapFacade map wrappers used across the app.

export function removeLayer(map: any, id: string) {
  try {
    if (!map) return;
    if (map.getLayer && map.getLayer(id + '-fill')) map.removeLayer(id + '-fill');
    if (map.getLayer && map.getLayer(id + '-outline')) map.removeLayer(id + '-outline');
    if (map.getLayer && map.getLayer(id + '-point')) map.removeLayer(id + '-point');
    if (map.getSource && map.getSource(id)) map.removeSource(id);
  } catch (e) {
    // swallowing minor map errors here - callers can log if needed
    console.debug('removeLayer helper error', e);
  }
}

function ensureSource(map: any, id: string) {
  if (!map) return;
  if (!map.getSource || !map.addSource) return;
  if (!map.getSource(id)) {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
  }
}

export function addFill(map: any, id: string, color: string) {
  ensureSource(map, id);
  if (!map.getLayer || !map.addLayer) return;
  if (!map.getLayer(id + '-fill')) {
    map.addLayer({
      id: id + '-fill',
      type: 'fill',
      source: id,
      paint: {
        'fill-color': color,
        'fill-opacity': 0.4
      }
    });
  }
}

export function addOutline(map: any, id: string, color: string) {
  ensureSource(map, id);
  if (!map.getLayer || !map.addLayer) return;
  if (!map.getLayer(id + '-outline')) {
    map.addLayer({
      id: id + '-outline',
      type: 'line',
      source: id,
      paint: {
        'line-color': color,
        'line-width': 2
      }
    });
  }
}

export function addPoint(map: any, id: string, color: string) {
  ensureSource(map, id);
  if (!map.getLayer || !map.addLayer) return;
  if (!map.getLayer(id + '-point')) {
    map.addLayer({
      id: id + '-point',
      type: 'symbol',
      source: id,
      layout: {
        'icon-image': 'mit-pin-' + color,
        'icon-anchor': 'bottom',
        'icon-size': 1,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
      },
      filter: ['==', '$type', 'Point']
    });
  }
}

export function setGeom(map: any, id: string, geom?: any | null) {
  if (!map || !map.getSource) return;
  const source = map.getSource(id);
  if (!source) return;
  if (!geom) {
    try {
      source.setData({ type: 'FeatureCollection', features: [] });
    } catch (e) {
      console.debug('setGeom helper error', e);
    }
    return;
  }
  try {
    source.setData(geom);
  } catch (e) {
    console.debug('setGeom helper error', e);
  }
}
